import { GQLLocale } from 'graphql-ts-types';

import { Locale } from '../../enums/Locale';

export const toGQLLocale = (locale: Locale) =>
  ({
    [Locale.De_At]: GQLLocale.DeAt,
    [Locale.De_Ch]: GQLLocale.DeCh,
    [Locale.De_De_H24]: GQLLocale.DeDe,
    [Locale.Fr_Be]: GQLLocale.FrBe,
    [Locale.Fr_Ch]: GQLLocale.FrCh,
    [Locale.Fr_Fr]: GQLLocale.FrFr,
    [Locale.It_It]: GQLLocale.ItIt,
    [Locale.Nl_Be]: GQLLocale.NlBe,
    [Locale.Nl_Nl]: GQLLocale.NlNl,
  })[locale];
